export enum EmailSourceType {
	Rune = 1,
	EmailGate = 2,
}
